import React from 'react';
import { useTranslation } from 'react-i18next';
import { NoResultContainer } from '../../styled.bottomSheetSelector';
import { Body4 } from '../../../common/typography';
import EmptySearch from '../../../common/icons/EmptySearch';
import { IHotelData } from '../../../@types/bottomSheet';
import { HotelItem } from '../HotelItem';

interface IBottomSheetHotelListProps {
  filteredHotels: IHotelData[];
  selectedHotelData: IHotelData | null;
  searchWords: string[];
  isItemSelected: (hotelData: IHotelData) => boolean;
  onHotelSelect: (hotelData: IHotelData) => void;
}

export function BottomSheetHotelList ({
  filteredHotels,
  selectedHotelData,
  searchWords,
  isItemSelected,
  onHotelSelect,
}: IBottomSheetHotelListProps) {
  const { t } = useTranslation();

  if (filteredHotels.length) {
    return (
      <>
        {filteredHotels.map((hotelData) => (
          <HotelItem
            key={`${hotelData.id}-${hotelData.brandId}-${hotelData.clientId}`}
            hotelData={hotelData}
            isChecked={isItemSelected(hotelData)}
            searchWords={searchWords}
            onClick={() => onHotelSelect(hotelData)}
          />
        ))}
      </>
    );
  }

  return (
    <NoResultContainer>
      {selectedHotelData && (
        <HotelItem
          hotelData={selectedHotelData}
          isChecked={true}
          searchWords={[]}
        />
      )}
      <Body4 color="battleShipGray">
        {t('COMMON.ALERT_MESSAGES.NO_RESULTS_FOUND_BY_TYPING')}
      </Body4>
      <EmptySearch />
    </NoResultContainer>
  );
}
